(() => {
  const selectors = {
    root: '[data-nazva-product-reviews]',
    anchor: '[data-nazva-reviews-anchor]',
    sort: '[data-nazva-review-sort]',
    list: '[data-nazva-review-list]',
    card: '.nazva-review-card',
    load: '[data-nazva-review-load]',
    modal: '[data-nazva-review-modal]',
    open: '[data-nazva-review-open]',
    close: '[data-nazva-review-close]',
    form: '[data-nazva-review-form]',
    formPanel: '[data-nazva-review-form-panel]',
    thanks: '[data-nazva-review-thanks]',
    error: '[data-nazva-review-error]',
    stars: '[data-nazva-review-stars]',
    ratingInput: '[data-nazva-review-rating-input]',
    files: '[data-nazva-review-files]',
    previews: '[data-nazva-review-previews]',
    counter: '[data-nazva-review-counter]',
    addPhoto: '[data-nazva-review-add]',
  };

  const MAX_FILES = 3;
  const MAX_DIMENSION = 1600; // px по большей стороне
  const JPEG_QUALITY = 0.85;

  // Состояние выбранных файлов на каждый блок отзывов (root).
  const rootState = new WeakMap();

  const bindFancybox = () => {
    if (!window.Fancybox) return;

    window.Fancybox.bind('[data-fancybox^="ReviewMedia-"]', {
      animated: true,
      dragToClose: true,
      Toolbar: {
        display: {
          left: [],
          middle: [],
          right: ['close'],
        },
      },
      Thumbs: false,
    });
  };

  const applyVisibleCount = (root, visibleCount) => {
    const cards = [...root.querySelectorAll(selectors.card)];
    const loadButton = root.querySelector(selectors.load);

    cards.forEach((card, index) => {
      card.hidden = index >= visibleCount;
    });

    if (loadButton) {
      loadButton.hidden = visibleCount >= cards.length;
    }
  };

  const sortCards = (root) => {
    const sort = root.querySelector(selectors.sort);
    const list = root.querySelector(selectors.list);
    if (!sort || !list) return;

    const cards = [...list.querySelectorAll(selectors.card)];
    const value = sort.value;

    cards.sort((a, b) => {
      const ratingA = Number(a.dataset.rating || 0);
      const ratingB = Number(b.dataset.rating || 0);
      const dateA = Number(a.dataset.date || 0);
      const dateB = Number(b.dataset.date || 0);

      if (value === 'oldest') return dateA - dateB;
      if (value === 'highest') return ratingB - ratingA || dateB - dateA;
      if (value === 'lowest') return ratingA - ratingB || dateB - dateA;
      return dateB - dateA;
    });

    cards.forEach((card) => list.appendChild(card));
    root.dataset.visibleCount = root.dataset.initialCount || '4';
    applyVisibleCount(root, Number(root.dataset.visibleCount));
  };

  const setRating = (root, value) => {
    const input = root.querySelector(selectors.ratingInput);
    const stars = [...root.querySelectorAll(`${selectors.stars} button`)];

    if (input) input.value = value;

    stars.forEach((button) => {
      const isActive = Number(button.dataset.rating) <= value && value > 0;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  };

  const setHoverRating = (root, value) => {
    const starsContainer = root.querySelector(selectors.stars);
    if (!starsContainer) return;
    
    starsContainer.classList.add('is-hovering');
    const stars = [...starsContainer.querySelectorAll('button')];
    
    stars.forEach((button) => {
      const isHovered = Number(button.dataset.rating) <= value;
      button.classList.toggle('is-hovered', isHovered);
    });
  };

  const clearHoverRating = (root) => {
    const starsContainer = root.querySelector(selectors.stars);
    if (starsContainer) {
      starsContainer.classList.remove('is-hovering');
      const stars = [...starsContainer.querySelectorAll('button')];
      stars.forEach(button => button.classList.remove('is-hovered'));
    }
  };

  // --- Загрузчик фото ---

  const renderUploader = (root) => {
    const state = rootState.get(root);
    const previews = root.querySelector(selectors.previews);
    if (!state || !previews) return;

    const counter = root.querySelector(selectors.counter);
    const addLabel = root.querySelector(selectors.addPhoto);

    previews.innerHTML = '';
    state.files.forEach((file, index) => {
      const item = document.createElement('div');
      item.className = 'nazva-review-uploader__item';

      const img = document.createElement('img');
      img.src = URL.createObjectURL(file);
      img.alt = '';
      img.addEventListener('load', () => URL.revokeObjectURL(img.src));

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'nazva-review-uploader__remove';
      remove.setAttribute('aria-label', 'remove');
      remove.textContent = '×';
      remove.addEventListener('click', () => {
        state.files.splice(index, 1);
        renderUploader(root);
      });

      item.append(img, remove);
      previews.appendChild(item);
    });

    if (counter) counter.textContent = `${state.files.length}/${MAX_FILES}`;
    if (addLabel) addLabel.hidden = state.files.length >= MAX_FILES;
  };

  const setupUploader = (root) => {
    const filesInput = root.querySelector(selectors.files);
    if (!filesInput) return;

    filesInput.addEventListener('change', () => {
      const state = rootState.get(root);
      if (!state) return;

      [...filesInput.files].forEach((file) => {
        if (state.files.length < MAX_FILES && file.type.startsWith('image/')) {
          state.files.push(file);
        }
      });
      filesInput.value = ''; // сброс, чтобы повторный выбор того же файла сработал
      renderUploader(root);
    });
  };

  // Ужимаем картинку до MAX_DIMENSION и пережимаем в JPEG, чтобы быстрее грузилось.
  // Если что-то пошло не так - отдаём оригинал, отзыв не должен падать из-за фото.
  const resizeImage = async (file) => {
    if (!file.type.startsWith('image/')) return file;

    let bitmap;
    try {
      bitmap = await createImageBitmap(file);
    } catch (error) {
      return file;
    }

    const scale = Math.min(1, MAX_DIMENSION / Math.max(bitmap.width, bitmap.height));
    const width = Math.round(bitmap.width * scale);
    const height = Math.round(bitmap.height * scale);

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext('2d');
    if (!ctx) {
      bitmap.close?.();
      return file;
    }
    ctx.fillStyle = '#ffffff'; // фон на случай прозрачного PNG
    ctx.fillRect(0, 0, width, height);
    ctx.drawImage(bitmap, 0, 0, width, height);
    bitmap.close?.();

    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', JPEG_QUALITY));
    if (!blob) return file;

    const name = file.name.replace(/\.[^.]+$/, '') + '.jpg';
    return new File([blob], name, { type: 'image/jpeg' });
  };

  const openModal = (root) => {
    const modal = root.querySelector(selectors.modal);
    const formPanel = root.querySelector(selectors.formPanel);
    const thanks = root.querySelector(selectors.thanks);
    const error = root.querySelector(selectors.error);
    if (!modal) return;

    // чистый старт нового отзыва
    const state = rootState.get(root);
    if (state) state.files.length = 0;
    renderUploader(root);

    if (formPanel) formPanel.hidden = false;
    if (thanks) thanks.hidden = true;
    if (error) error.hidden = true;
    modal.hidden = false;
    document.documentElement.classList.add('nazva-review-modal-open');
    setRating(root, Number(root.querySelector(selectors.ratingInput)?.value || 0));
    modal.querySelector('.nazva-review-modal__dialog')?.focus();
  };

  const closeModal = (root) => {
    const modal = root.querySelector(selectors.modal);
    if (!modal) return;

    modal.hidden = true;
    document.documentElement.classList.remove('nazva-review-modal-open');
  };

  const showThanks = (root) => {
    const formPanel = root.querySelector(selectors.formPanel);
    const thanks = root.querySelector(selectors.thanks);
    const error = root.querySelector(selectors.error);

    if (formPanel) formPanel.hidden = true;
    if (thanks) thanks.hidden = false;
    if (error) error.hidden = true;
  };

  const submitReview = async (root, form) => {
    const submit = form.querySelector('[type="submit"]');
    const endpoint = root.dataset.submissionEndpoint;
    const error = root.querySelector(selectors.error);
    const input = root.querySelector(selectors.ratingInput);
    const state = rootState.get(root);

    if (!input || Number(input.value) === 0) {
      if (error) {
        error.textContent = "Будь ласка, виберіть рейтинг";
        error.hidden = false;
      }
      return;
    }

    const originalLabel = submit ? submit.textContent : '';
    const sendingLabel = root.dataset.sendingText || originalLabel;

    if (submit) {
      submit.disabled = true;
      submit.classList.add('is-loading');
      submit.textContent = sendingLabel;
    }
    if (error) error.hidden = true;

    try {
      // Ужимаем фото на клиенте перед отправкой.
      const resized = [];
      for (const file of (state ? state.files : [])) {
        resized.push(await resizeImage(file));
      }

      const formData = new FormData(form);
      formData.delete('media[]');
      resized.forEach((file) => formData.append('media[]', file, file.name));

      const response = await fetch(endpoint, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error(`Review submission failed with status ${response.status}`);
      }

      form.reset();
      if (state) state.files.length = 0;
      renderUploader(root);
      setRating(root, 0);
      showThanks(root);
    } catch (errorReason) {
      console.error(errorReason);
      if (error) error.hidden = false;
    } finally {
      if (submit) {
        submit.disabled = false;
        submit.classList.remove('is-loading');
        submit.textContent = originalLabel;
      }
    }
  };

  const initRoot = (root) => {
    if (root.dataset.nazvaReviewsReady === 'true') return;
    root.dataset.nazvaReviewsReady = 'true';
    root.dataset.visibleCount = root.dataset.initialCount || '4';

    rootState.set(root, { files: [] });

    applyVisibleCount(root, Number(root.dataset.visibleCount));
    sortCards(root);
    setRating(root, 0);
    setupUploader(root);
    renderUploader(root);

    root.querySelector(selectors.sort)?.addEventListener('change', () => sortCards(root));

    root.querySelector(selectors.load)?.addEventListener('click', () => {
      const current = Number(root.dataset.visibleCount || root.dataset.initialCount || 4);
      const step = Number(root.dataset.loadStep || 4);
      root.dataset.visibleCount = String(current + step);
      applyVisibleCount(root, Number(root.dataset.visibleCount));
    });

    root.querySelectorAll(selectors.open).forEach((button) => {
      button.addEventListener('click', () => openModal(root));
    });

    root.querySelectorAll(selectors.close).forEach((button) => {
      button.addEventListener('click', () => closeModal(root));
    });

    root.querySelectorAll(`${selectors.stars} button`).forEach((button) => {
      button.addEventListener('click', () => setRating(root, Number(button.dataset.rating)));
      button.addEventListener('mouseenter', () => setHoverRating(root, Number(button.dataset.rating)));
    });

    root.querySelector(selectors.stars)?.addEventListener('mouseleave', () => clearHoverRating(root));

    root.querySelector(selectors.form)?.addEventListener('submit', (event) => {
      event.preventDefault();
      submitReview(root, event.currentTarget);
    });
  };

  const init = () => {
    bindFancybox();

    document.querySelectorAll(selectors.root).forEach(initRoot);

    document.querySelectorAll(selectors.anchor).forEach((anchor) => {
      anchor.addEventListener('click', (event) => {
        const target = document.querySelector(anchor.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
